
import React, { Component } from 'react';
import 'antd/dist/antd.css';
import '../css/lista_titular_comites.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserEdit, faUserTimes, faUserTie } from '@fortawesome/free-solid-svg-icons';
import '../css/lista_representantes.css';
import { Row, Col} from 'antd';
import {Link} from 'react-router-dom';
import { Table, Divider} from 'antd';
import { Modal, Button, message } from 'antd';

import {logout, titular_comite_representantes, eliminar_representante, actualizarTitular} from '../utils/JWTAuth';

import  NavBar  from './NavBar';

let lista_titular_comite_representantes;
let comite, state, borrar_representante = 0;
let nuevo_representante_id, url;

const success = (messages) => {
  message.success(messages);
};

const error = (messages) => {
  message.error(messages);
};

const warning = (messages) => {
  message.warning(messages);
};

const borrarRepresentante = (e)=>{
  borrar_representante = e.currentTarget.getAttribute('data-id-representante');

  

  state.setState({
    visibleBorrar: true
  });

}

const cambiarAdmin = (e) => {
    nuevo_representante_id = e.currentTarget.getAttribute('data-id-representante');
    

    state.setState({
      visibleAdmin: true
    });

}

const columns_admin = [
  {
    title: 'Nombre',
    dataIndex: 'nombre',
    key: 'nombre',
  render: text => <span>{text}</span>,
  },
  {
    title: 'E-mail',
    dataIndex: 'email',
    key: 'email',
    render: text => <span><a href={`mailto:${text}`}>{text}</a></span>,
  },
  {
    title: 'Teléfono',
    dataIndex: 'telefono',
    key: 'telefono',
    render: text => <span><a href={`tel:${text}`}>{text}</a></span>,
  },
  {
    title: 'Cargo en la Empresa',
    dataIndex: 'cargo',
    key: 'cargo',
    render: text => <span>{text}</span>,
  },
  {
    title: 'Profesión',
    dataIndex: 'profesion',
    key: 'profesion',
    render: text => <span>{text}</span>,
  },
  {
    title: 'Representante',
    dataIndex: 'is_titular',
    key: 'is_titular',
    render: (text, record) => (
      <span>
        {text ?
          (
          <FontAwesomeIcon className="icon_user_admin" icon={ faUserTie } />
          )
          :
          (<FontAwesomeIcon onClick={cambiarAdmin} data-id-representante={record.representante_id} className="icon_user_no_admin" icon={ faUserTie } />)

        }
      </span>
    ),
  },
  {
    title: 'Editar',
    dataIndex: 'representante_id',
    key: 'representante_id',
    render: (text, record) => (
      <span>
        <Link to={"/representante/"+state.props.match.params.num_comite+"/usuario/"+text}>
          <FontAwesomeIcon data-id-representante={text} className="icon_user_edit" icon={faUserEdit} />
        </Link>
        <Divider type="vertical" />
        {!record.is_titular && 
        (<FontAwesomeIcon onClick={borrarRepresentante} data-id-representante={text} className="icon_user_delete" icon={faUserTimes} />)
        }
        
      </span>
    ),
  },
];

const columns_usuario = [
  {
    title: 'Nombre',
    dataIndex: 'nombre',
    key: 'nombre',
  render: text => <span>{text}</span>,
  },
  {
    title: 'E-mail',
    dataIndex: 'email',
    key: 'email',
    render: text => <span><a href={`mailto:${text}`}>{text}</a></span>,
  },
  {
    title: 'Teléfono',
    dataIndex: 'telefono',
    key: 'telefono',
    render: text => <span><a href={`tel:${text}`}>{text}</a></span>,
  },
  {
    title: 'Cargo en la Empresa',
    dataIndex: 'cargo',
    key: 'cargo',
    render: text => <span>{text}</span>,
  },
  {
    title: 'Profesión',
    dataIndex: 'profesion',
    key: 'profesion',
    render: text => <span>{text}</span>,
  },
  
  {
    title: 'Editar',
    dataIndex: 'representante_id',
    key: 'representante_id',
    render: (text, record) => (
      <span>
        <Link to={"/representante/"+state.props.match.params.num_comite+"/usuario/"+text}>
          <FontAwesomeIcon data-id-representante={text} className="icon_user_edit" icon={faUserEdit} />
        </Link>
       
        
      </span>
    ),
  },
];





  function onChange(pagination, filters, sorter, extra) {
    
  }

class ListaAdminRepresentantes extends Component {


  constructor(props){
    super(props);

    state = this;
    

    this.state = {
      visibleBorrar: false,
      visibleAdmin: false,
      representantes: [{
        is_titular:false
      }],
      nombre_comite: ''
    } 

    this.actualizarRepresentantes();

   
    
  }

  componentWillMount() {
    switch(state.props.match.params.num_comite){
      case '1': state.setState({nombre_comite:'Comité de Seguridad Vial'}); break;
      case '2': state.setState({nombre_comite:'Comité de Prevención y Combate al Delito'}); break;
      case '3': state.setState({nombre_comite:'Comité de Movilidad'}); break;
      case '4': state.setState({nombre_comite:'Comité Ferroviario'}); break;
      case '5': state.setState({nombre_comite:'Comité Jurídico'}); break;
      case '6': state.setState({nombre_comite:'Comité Técnico'}); break;
      default:  break;
  }

 
  }

  

  actualizarRepresentantes(){

  

    titular_comite_representantes(state.props.match.params.num_comite).then(data => {


      

      switch(data.status){
        case 0:
          this.setState({
            representantes: data.data
          });



        break;
        case 5:
          error('Error de Conexión');
        break;
      }

    });

    

  }
  
  

    componentDidMount() {
      const { match: { params } } = this.props;

      comite = params.comite;

      state.setState({
        comite: params.comite
      });

      

    }

    handleOkBorrar = e => {
      

      eliminar_representante(state.props.match.params.num_comite,borrar_representante).then(data => {

        switch(data.status){
          case 5:
            error('Error de Conexión');
            break;
          case 10:
            success('Usuario Eliminado');
            break;
        }

        this.actualizarRepresentantes();

      });

      this.setState({
        visibleBorrar: false,
      });


    };

    handleOkAdmin = e => {
      

      let dataJson = {
        "representante_id":nuevo_representante_id,
        "comite_id": state.props.match.params.num_comite
      }
        actualizarTitular(dataJson).then(data => {
    
        switch(data.status){
          case 0:
            success('Administrador cambiado');
            state.actualizarRepresentantes();
            break;
          case 5:
            error('Error de Conexión');
            switch(state.props.match.params.num_comite){
              case 1: url = 'comite-nacional-seguridad-vial'; break;
              case 2: url = 'comite-prevencion-y-combate-al-delito'; break;
              case 3: url = 'comite-movilidad'; break;
              case 4: url = 'comite-ferroviario'; break;
              case 5: url = 'comite-juridico'; break;
              case 6: url = 'comite-tecnico'; break;
            }
        
            window.location.href = '/login/'+url+'/'+state.props.match.params.num_comite;
            break;
          
        }
    
        });
    
      

      this.setState({
        visibleAdmin: false,
      });
    };
  
    handleCancel = e => {
      
      this.setState({
        visibleBorrar: false,
        visibleAdmin: false
      });
    };
  

    render(){
        return(

          <Row>
            <Modal
              title="Eliminar Registro"
              visible={this.state.visibleBorrar}
              onOk={this.handleOkBorrar}
              onCancel={this.handleCancel}
            >
              <p>¿Esta seguro de eliminar este representante?</p>
            </Modal>

            <Modal
              title="Cambiar de Administrador"
              visible={this.state.visibleAdmin}
              onOk={this.handleOkAdmin}
              onCancel={this.handleCancel}
            >
              <p>¿Esta seguro de cambiar al administrador?</p>
            </Modal>

            <Col span={18} offset={4}>
              <br />
              <h1 style={{ textAlign: 'center'}}>{state.state.nombre_comite}</h1>
              <br />
            </Col>
            
            <NavBar admin_empresa={state.state.representantes[0].is_titular} comite={state.props.match.params.num_comite} />
            
            <Col span={16}>
            <Table
            columns={state.state.representantes.length > 1 ? columns_admin : columns_usuario}
             dataSource={this.state.representantes} onChange={onChange} />
            </Col>
          </Row>




            
        );
    }
}

export default ListaAdminRepresentantes;

